export default "__VITE_ASSET__DCh2_Qgu__"